import { useEffect, useState } from 'react'

/**
 * Giá trị trễ `ms` sau lần đổi cuối. Dùng cho ô tìm kiếm: gõ liên tục không bắn
 * một request mỗi phím (trước đây `ProductList`/`MediaLibrary` gọi API theo từng keystroke).
 */
export function useDebounced<T>(value: T, ms = 300): T {
  const [v, setV] = useState(value)
  useEffect(() => {
    const t = window.setTimeout(() => setV(value), ms)
    return () => window.clearTimeout(t)
  }, [value, ms])
  return v
}
